import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Card, Statistic } from 'antd';
import { routePaths } from 'router';
import { buildPathWithFilters } from 'shared/utils/filters/build-path-with-filters';
import styles from './future-expenses-totals.module.scss';
import type { IFutureExpensesTotalsProps } from './types';

export const FutureExpensesTotals: React.FC<IFutureExpensesTotalsProps> = (props) => {
  const { totals } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Card>
        <Statistic
          title={t('future-payments:estimated_expenses')}
          value={totals.estimatedExpenses}
          suffix='€'
          precision={1}
        />
      </Card>
      <Card>
        <Statistic
          title={t('future-payments:overdue_expenses_count')}
          value={totals.overdueExpensesCount}
          suffix={
            <Link className={styles.showLink} to={buildPathWithFilters(routePaths.expenses, { overdue: true })}>
              {t('common:show')}
            </Link>
          }
        />
      </Card>
      <Card>
        <Statistic
          title={t('future-payments:overdue_expenses_amount')}
          value={totals.overdueExpensesAmount}
          suffix='€'
          precision={1}
        />
      </Card>
    </div>
  );
};
